import React, { useState } from 'react';
import './FormationsPermisB.css';

const FormationsPermisB = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFormule, setSelectedFormule] = useState(null);

  const formules = [
    {
      id: '20h-sans-code',
      heures: '20 H',
      avecCode: false,
      accompagnee: false,
      prestations: [
        'Gestion de dossier & dossier préfectoral',
        '20 leçons de conduite',
        'Pochette pédagogique (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
        'Assurance garantie financière',
        'Accompagnement à l\'examen de conduite par un enseignant diplômé'
      ],
      complementaires: [
        'Évaluation de départ'
      ],
      prix: 900
    },
    {
      id: '30h-sans-code',
      heures: '30 H',
      avecCode: false,
      accompagnee: false,
      prestations: [
        'Gestion de dossier & dossier préfectoral',
        '30 leçons de conduite',
        'Pochette pédagogique (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
        'Assurance garantie financière',
        'Accompagnement à l\'examen de conduite par un enseignant diplômé'
      ],
      complementaires: [
        'Évaluation de départ'
      ],
      prix: 1200
    },
    {
      id: '20h-avec-code',
      heures: '20 H',
      avecCode: true,
      accompagnee: false,
      prestations: [
        'Gestion de dossier & dossier préfectoral',
        'Accès en salle cours & test en illimité',
        '20 leçons de conduite',
        'Pochette pédagogique (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
        'Assurance garantie financière',
        'Prepa code mobile (accès 12 mois)',
        'Accompagnement à l\'examen de conduite par un enseignant diplômé'
      ],
      complementaires: [
        'Redevance ETG',
        'Code mobile'
      ],
      prix: 990
    },
    {
      id: '30h-avec-code',
      heures: '30 H',
      avecCode: true,
      accompagnee: false,
      prestations: [
        'Gestion de dossier & dossier préfectoral',
        'Accès en salle cours & test en illimité',
        '30 leçons de conduite',
        'Pochette pédagogique (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
        'Assurance garantie financière',
        'Prepa code mobile (accès 12 mois)',
        'Accompagnement à l\'examen de conduite par un enseignant diplômé'
      ],
      complementaires: [
        'Redevance ETG',
        'Code mobile'
      ],
      prix: 1290
    },
    {
      id: '20h-accompagnée',
      heures: '20 H',
      avecCode: false,
      accompagnee: true,
      prestations: [
        'Gestion de dossier & dossier préfectoral',
        'Accès en salle cours & test en illimité',
        '20 leçons de conduite',
        'Pochette pédagogique (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
        'Assurance garantie financière',
        'Rendez-vous préalable et rendez-vous pédagogiques (conduite accompagnée)',
        'Accompagnement à l\'examen de conduite par un enseignant diplômé'
      ],
      complementaires: [
        'Redevance ETG'
      ],
      prix: 1300
    }
  ];

  const handleOpenModal = (formule) => {
    setSelectedFormule(formule);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFormule(null);
  };

  return (
    <div className="formations-permis-b-page">
      <section className="permis-b-hero">
        <div className="container">
          <div className="hero-content-permis-b">
            <h1 className="permis-b-title">Formation Permis B</h1>
            <p className="permis-b-subtitle">Choisissez la formule qui correspond à vos besoins</p>
            <p className="hero-description-permis-b">
              Que vous ayez déjà votre code ou que vous souhaitiez l'obtenir avec nous, 
              nous avons la formation adaptée pour vous accompagner vers la réussite.
            </p>
          </div>
        </div>
      </section>

      <section className="permis-b-content">
        <div className="container">
          {/* Section Sans Code */}
          <div className="formules-section">
            <h2 className="section-title">Sans Code</h2>
            <div className="formules-grid">
              {formules.filter(f => !f.avecCode && !f.accompagnee).map((formule) => (
                <div key={formule.id} className="formule-card">
                  <div className="formule-header">
                    <div className="formule-header-box">
                      <h3 className="formule-title">FORMULE {formule.heures}</h3>
                      <p className="formule-subtitle">SANS CODE</p>
                    </div>
                  </div>
                  
                  <div className="formule-prestations">
                    <h4 className="prestations-title">Prestations incluses :</h4>
                    <ul className="prestations-list">
                      {formule.prestations.map((prestation, index) => (
                        <li key={index} className="prestation-item included">
                          <span className="prestation-icon">✓</span>
                          <span className="prestation-text">{prestation}</span>
                        </li>
                      ))}
                    </ul>

                    {formule.complementaires.length > 0 && (
                      <>
                        <h5 className="complementaires-title">Prestations complémentaires :</h5>
                        <ul className="prestations-list">
                          {formule.complementaires.map((prestation, index) => (
                            <li key={index} className="prestation-item complementary">
                              <span className="prestation-icon">+</span>
                              <span className="prestation-text">{prestation}</span>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}

                    <button 
                      onClick={() => handleOpenModal(formule)} 
                      className="btn btn-tarifs"
                    >
                      VOIR NOS TARIFS
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section Avec Code */}
          <div className="formules-section">
            <h2 className="section-title">Avec Code</h2>
            <div className="formules-grid">
              {formules.filter(f => f.avecCode && !f.accompagnee).map((formule) => (
                <div key={formule.id} className="formule-card formule-avec-code">
                  <div className="formule-header">
                    <div className="formule-badge">AVEC CODE</div>
                    <div className="formule-header-box">
                      <h3 className="formule-title">FORMULE {formule.heures}</h3>
                      <p className="formule-subtitle">AVEC CODE</p>
                    </div>
                  </div>
                  
                  <div className="formule-prestations">
                    <h4 className="prestations-title">Prestations incluses :</h4>
                    <ul className="prestations-list">
                      {formule.prestations.map((prestation, index) => (
                        <li key={index} className="prestation-item included">
                          <span className="prestation-icon">✓</span>
                          <span className="prestation-text">{prestation}</span>
                        </li>
                      ))}
                    </ul>

                    {formule.complementaires.length > 0 && (
                      <>
                        <h5 className="complementaires-title">Prestations complémentaires :</h5>
                        <ul className="prestations-list">
                          {formule.complementaires.map((prestation, index) => (
                            <li key={index} className="prestation-item complementary">
                              <span className="prestation-icon">+</span>
                              <span className="prestation-text">{prestation}</span>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}

                    <button 
                      onClick={() => handleOpenModal(formule)} 
                      className="btn btn-tarifs"
                    >
                      VOIR NOS TARIFS
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section Formule Accompagnée */}
          <div className="formules-section">
            <h2 className="section-title">Formule Accompagnée</h2>
            <div className="formules-grid formules-grid-single">
              {formules.filter(f => f.accompagnee).map((formule) => (
                <div key={formule.id} className="formule-card formule-accompagnée">
                  <div className="formule-header">
                    <div className="formule-badge">ACCOMPAGNÉE</div>
                    <div className="formule-header-box">
                      <h3 className="formule-title">FORMULE {formule.heures}</h3>
                      <p className="formule-subtitle">CONDUITE ACCOMPAGNÉE</p>
                    </div>
                  </div>
                  
                  <div className="formule-prestations">
                    <h4 className="prestations-title">Prestations incluses :</h4>
                    <ul className="prestations-list">
                      {formule.prestations.map((prestation, index) => (
                        <li key={index} className="prestation-item included">
                          <span className="prestation-icon">✓</span>
                          <span className="prestation-text">{prestation}</span>
                        </li>
                      ))}
                    </ul>

                    {formule.complementaires.length > 0 && (
                      <>
                        <h5 className="complementaires-title">Prestations complémentaires :</h5>
                        <ul className="prestations-list">
                          {formule.complementaires.map((prestation, index) => (
                            <li key={index} className="prestation-item complementary">
                              <span className="prestation-icon">+</span>
                              <span className="prestation-text">{prestation}</span>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}

                    <button 
                      onClick={() => handleOpenModal(formule)} 
                      className="btn btn-tarifs"
                    >
                      VOIR NOS TARIFS
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modal Tarifs */}
      {modalOpen && selectedFormule && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal}>×</button>
            <h3 className="modal-title">
              Tarif - {selectedFormule.accompagnee ? `Formule accompagnée ${selectedFormule.heures}` : `Formule ${selectedFormule.heures}`}
            </h3>
            <div className="modal-price">
              <p className="price-label">À partir de</p>
              <p className="price-amount">{selectedFormule.prix} € TTC</p>
            </div>
            <p className="modal-description">
              Pour plus d'informations et connaître le tarif exact adapté à votre situation, 
              n'hésitez pas à nous contacter.
            </p>
            <a href="/contact" className="btn btn-contact-modal">
              NOUS CONTACTER
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormationsPermisB;
